import {createContext} from 'react';

type DialogsContextType = {
  isAnyDialogOpen: boolean;
};

export const DialogsContext = createContext<DialogsContextType>({
  isAnyDialogOpen: false,
});
